module.exports = __webpack_public_path__ + "img/video-purple.9d8dec82.svg";